import { useEffect } from 'react';
import { gql, useMutation } from '@apollo/client';

import {
  SET_ON_CONTINUE,
  SET_LOADING,
  SET_SUCCESS,
} from '../../reducers/actionReducer';
import LoadingSpinner from '../LoadingSpinner';
import ErrorText from '../ErrorText';

const RESET_PASSWORD = gql`
  mutation ResetPassword($email: String!) {
    resetPassword(email: $email) {
      email
    }
  }
`;

export default function SendPasswordReset({ email, dispatchAction }) {
  const [resetPassword, { loading, error, called, data }] =
    useMutation(RESET_PASSWORD);

  useEffect(() => {
    if (email && resetPassword) {
      dispatchAction({
        type: SET_ON_CONTINUE,
        payload: {
          onContinue: () => resetPassword({ variables: { email } }),
        },
      });
    }
  }, [dispatchAction, email, resetPassword]);

  useEffect(() => {
    if (loading !== undefined) {
      dispatchAction({
        type: SET_LOADING,
        payload: { loading },
      });
    }
  }, [dispatchAction, loading]);

  useEffect(() => {
    if (called && data && !error) {
      dispatchAction({
        type: SET_SUCCESS,
        payload: {
          message: 'Password reset email sent.',
        },
      });
    }
  }, [called, data, dispatchAction, error]);

  return (
    <div className="flex flex-col justify-center items center text-center space-y-4">
      {loading && <LoadingSpinner />}
      {error && <ErrorText message={error.message} />}
      {!loading && !error && (
        <>
          <p>
            This will send a password reset email to this user. They will be
            able to choose a new password by clicking on the link in the email.
          </p>
          <p>
            This does not change the user's current password. They could still
            log in with their old password prior to changing it using the
            provided link.
          </p>
          <p>Would you like to continue?</p>
        </>
      )}
    </div>
  );
}
